import { render, staticRenderFns } from "./PlanSetup.vue?vue&type=template&id=0c2f8592"
import script from "./PlanSetup.vue?vue&type=script&lang=js"
export * from "./PlanSetup.vue?vue&type=script&lang=js"
import style0 from "./PlanSetup.vue?vue&type=style&index=0&id=0c2f8592&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports